import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { addDesHistory } from "../../designationHistory/designationHistoryApis";
import BtnEditSvg from "../Button/btnEditSvg";

const DesignationEditSinglePopup = ({ data, setLoading }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [EffectedFrom, setEffectedFrom] = useState(
        data?.EffectedFrom ? dayjs(data.EffectedFrom).format("YYYY-MM-DD") : null
    );
    const [EffectedTo, setEffectedTo] = useState(
        data?.EffectedTo ? dayjs(data.EffectedTo).format("YYYY-MM-DD") : null
    );
    const [loader, setLoader] = useState(false);
    const [designationComment, setDesignationComment] = useState("");

    const user_id = useParams("id");
    const dispatch = useDispatch();
    const designations = useSelector((state) => state.designations.list);
    const [DesignationId, setDesignationId] = useState(
        data?.designation?.DesignationId || data?.DesignationId
    );

    const [initialValues, setInitialValues] = useState({
        DesignationId: data?.DesignationId || "",
        EffectedFrom: data?.EffectedFrom ? dayjs(data.EffectedFrom) : null,
        EffectedTo: data?.EffectedTo ? dayjs(data.EffectedTo) : null,
    });

    useEffect(() => {
        if (data) {
            setInitialValues({
                DesignationId: data.DesignationId || "",
                EffectedFrom: data.EffectedFrom ? dayjs(data.EffectedFrom) : null,
                EffectedTo: data.EffectedTo ? dayjs(data.EffectedTo) : null,
            });
            setDesignationId(data.DesignationId || data?.designation?.DesignationId);
            setEffectedFrom(data.EffectedFrom ? dayjs(data.EffectedFrom).format("YYYY-MM-DD") : null);
            setEffectedTo(data.EffectedTo ? dayjs(data.EffectedTo).format("YYYY-MM-DD") : null);
        }
    }, [data]);

    const onFinish = async (values) => {
        setLoading(true);
        setLoader(true);

        const infodata = {
            DesignationHistoryId: data.DesignationHistoryId || 0,
            EmployeeId: user_id.id,
            DesignationId: DesignationId,
            EffectedFrom: EffectedFrom,
            EffectedTo: EffectedTo,
            DataStatus: 1,
        };

        const resp = await addDesHistory(infodata);

        if (resp.message === "success") {
            setLoader(false);
            dispatch(loadSingleStaff(user_id.id));
            setInitialValues({});
            setDesignationId("");
            setDesignationComment("");
            setEffectedFrom(null);
            setEffectedTo(null);
            setIsModalOpen(false);
            setLoading(false);
        } else {
            setLoading(false);
            setLoader(false);
            toast.error(resp.message || "Failed to update designation");
        }
    };

    const onFinishFailed = (errorInfo) => {
        toast.warning("Failed at updating designation");
        setLoader(false);
        setLoading(false);
    };

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setDesignationId("");
        setDesignationComment("");
        setEffectedFrom(null);
        setEffectedTo(null);
        setIsModalOpen(false);
        setLoader(false);
        setLoading(false);
    };

    const handleCancel = () => {
        setDesignationId("");
        setDesignationComment("");
        setEffectedFrom(null);
        setEffectedTo(null);
        setIsModalOpen(false);
        setLoader(false);
        setLoading(false);
    };

    return (
        <>
            <button onClick={showModal} className="mr-2">
                <BtnEditSvg size={20} />
            </button>
            <Modal
                title={`Edit Designation`}
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
            >
                <Form
                    style={{ marginBottom: "100px" }}
                    eventKey="design-form"
                    initialValues={initialValues}
                    name="basic"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >
                    <div>
                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            label="Designation"
                            name="DesignationId"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your Designation!",
                                },
                            ]}
                        >
                            <Select
                                placeholder="Select Designation"
                                onChange={(value) => setDesignationId(value)}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {designations?.map((item) => (
                                    <Select.Option key={item.DesignationId} value={item.DesignationId}>
                                        {item.DesignationName || ""}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            label="Effected From"
                            name="EffectedFrom"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your Effected From!",
                                },
                            ]}
                        >
                            <DatePicker
                                name="EffectedFrom"
                                format="YYYY-MM-DD"
                                value={EffectedFrom ? dayjs(EffectedFrom, "YYYY-MM-DD") : null}
                                onChange={(date) => setEffectedFrom(date ? date.format("YYYY-MM-DD") : null)}
                            />
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "10px" }}
                            label="Effected To"
                            name="EffectedTo"
                        >
                            <DatePicker
                                name="EffectedTo"
                                format="YYYY-MM-DD"
                                value={EffectedTo ? dayjs(EffectedTo, "YYYY-MM-DD") : null}
                                onChange={(date) => setEffectedTo(date ? date.format("YYYY-MM-DD") : null)}
                            />
                        </Form.Item>

                        <Form.Item
                            style={{ marginBottom: "20px" }}
                            wrapperCol={{ offset: 6, span: 12 }}
                        >
                            <Button
                                onClick={() => setLoader(true)}
                                type="primary"
                                size="small"
                                htmlType="submit"
                                block
                                loading={loader}
                            >
                                Update Now
                            </Button>
                        </Form.Item>
                    </div>
                </Form>
            </Modal>
        </>
    );
};

export default DesignationEditSinglePopup;